import {
  faChevronSquareDown as faChevronSquareDownRegular,
  faChevronSquareUp as faChevronSquareUpRegular,
  faExclamationSquare as faExclamationSquareRegular,
  faSquare as faSquareRegular,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faChevronSquareDown,
  faChevronSquareUp,
  faExclamationSquare,
  faSquare,
} from '@fortawesome/pro-solid-svg-icons';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';

export const severityIcons: IconProp[] = [
  faSquare,
  faChevronSquareDown,
  faChevronSquareUp,
  faExclamationSquare,
];
export const hollowSeverityIcons: IconProp[] = [
  faSquareRegular,
  faChevronSquareDownRegular,
  faChevronSquareUpRegular,
  faExclamationSquareRegular,
];
